import React from 'react';
import PropTypes from 'prop-types';
import {Layout} from 'antd';
import classNames from 'classnames';

import styles from './AppLayout.module.less';

const AppLayout = ({
    className,
    header,
    headerClassName,
    mainClassName,
    sider,
    contentContainerClassName,
    style,
    children,
}) => {
    return (
        <Layout className={classNames(styles.container, className)}>
            <Layout.Header className={classNames(styles.header, headerClassName)}>
                {header}
            </Layout.Header>
            <Layout className={classNames(styles.layout, mainClassName)}>
                {sider && (
                    <Layout.Sider theme="light" className={styles.sidebar}>
                        {sider}
                    </Layout.Sider>
                )}
                <Layout.Content
                    className={classNames(
                        styles.contentContainer,
                        {[styles.noSiderContentContainer]: !sider},
                        contentContainerClassName
                    )}
                >
                    <div className={styles.content} style={style}>
                        {children}
                    </div>
                </Layout.Content>
            </Layout>
        </Layout>
    );
};

AppLayout.propTypes = {
    className: PropTypes.string,
    header: PropTypes.node,
    headerClassName: PropTypes.string,
    mainClassName: PropTypes.string,
    sider: PropTypes.node,
    contentContainerClassName: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
};

export default AppLayout;
